import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryNewZealand = () => {
  const navigate = useNavigate();

  const NewzealandData = {
    title: "Study Abroad Opportunities Newzealand",
    mTitle: "Why Study in the Newzealand?",
    desc_1:
      "The United States stands as a global leader in higher education, offering an unparalleled diversity of academic programs and institutions. With its cutting-edge research facilities, innovative teaching methods, and strong support for international students, studying in the Newzealand opens doors to global opportunities.",
    desc_2:
      "In the Newzealand, you’ll find not only academic excellence but also a diverse cultural environment, internships, and strong industry ties. It’s more than education—it’s a life experience.",
  };

  const NewzealandBenefits = [
    { title: "World-Class Education", number: 550, suffix: "+" },
    { title: "Diverse Academic Programs", number: 100, suffix: "%" },
    { title: "Top-Ranked Universities", number: 300, suffix: "+" },
    { title: "Strong Industry Connections", number: 550, suffix: "+" },
  ];

  const NewzealandUniversities = [
  {
    title: "University of Auckland",
    img: "/image/study-abroad/nz/university-of-auckland.jpg",
    link: "#",
  },
  {
    title: "University of Otago",
    img: "/image/study-abroad/nz/university-of-otago.png",
    link: "#",
  },
  {
    title: "Victoria University of Wellington",
    img: "/image/study-abroad/nz/victoria-university-of-wellington.png",
    link: "#",
  },
  {
    title: "University of Canterbury",
    img: "/image/study-abroad/nz/university-of-canterbury.png",
    link: "#",
  },
  {
    title: "University of Waikato",
    img: "/image/study-abroad/nz/university-of-waikato.png",
    link: "#",
  },
  {
    title: "Massey University",
    img: "/image/study-abroad/nz/massey-university.png",
    link: "#",
  },
  {
    title: "Auckland University of Technology (AUT)",
    img: "/image/study-abroad/nz/auckland-university-of-technology.png",
    link: "#",
  },
  {
    title: "Lincoln University",
    img: "/image/study-abroad/nz/lincoln-university.png",
    link: "#",
  },
  {
    title: "Unitec Institute of Technology",
    img: "/image/study-abroad/nz/unitec-institute-of-technology.png",
    link: "#",
  },
  {
    title: "Manukau Institute of Technology",
    img: "/image/study-abroad/nz/manukau-institute-of-technology.png",
    link: "#",
  },
];



  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {NewzealandData.title}
        </h1>

        {/* Carousel After Main Title */}
        <div className="mb-10 mt-10">
<h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">Top Universities in the Newzealand</h3>
        <p className="text-gray-600 mb-6 mt-5">Explore Our Partner Institutions</p>

             <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
            renderButtonGroupOutside={false}
          >
            {NewzealandUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">{univ.title}</h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>

        </div>

        {/* Rest of the Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">{NewzealandData.mTitle}</h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{NewzealandData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{NewzealandData.desc_2}</p>
       
         <img
          src="/image/about/about-07/new-zealand.png"
          alt="Study in New Zealand"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
        
      </section>

        

      {/* Features Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Benefits of Studying in the Newzealand</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {NewzealandBenefits.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100">
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryNewZealand;
